// @ts-nocheck

import { useSelector } from 'react-redux';

import { makeHistoryEntitiesOutcomesEntitySelector } from '../../../components/HistoryItem/HistoryItem.selector';
import useMergeProps from '../../../hooks/useMergeProps';
import HallOfFameOutcome from '../components/HallOfFameOutcome';

const HallOfFameOutcomeContainer = (ownProps) => {
  const selector = makeHistoryEntitiesOutcomesEntitySelector();

  const selectedProps = useSelector((state) => selector(state, { ...ownProps }));

  const enhancedProps = useMergeProps({ selectedProps, ownProps });

  return <HallOfFameOutcome {...enhancedProps} />;
};

export default HallOfFameOutcomeContainer;
